(function() {
  'use strict';

  var menuToggler = document.querySelector('.section-header .menu-toggle');
  var sectionHeader = document.querySelector('.section-header');

  menuToggler.addEventListener('click', function () {
    sectionHeader.classList.toggle('menu-open');
  }, false);

  document.body.addEventListener('click', function (event) {
    event = event || window.event;
    var wasClickOnMenu = event.currentTarget.closest('.menu');

    if (wasClickOnMenu) return;
    if (event.target === menuToggler) return;
    sectionHeader.classList.remove('menu-open');
  }, false);
}());
